import { Component, OnInit } from '@angular/core';
import moment from 'moment-timezone';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'final-date-mission-custom',
    templateUrl: './final-date-mission-custom.component.html',
    styleUrls: ['./final-date-mission-custom.component.scss'],
    standalone: false
})
export class FinalDateMissionCustomComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  firstChoice;
  firstChoiceValue;
  secondChoice;
  secondChoiceValue;
  startDateMission: Date;
  isShiftedMission: boolean = true;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    this.startDateMission = new Date(
      pledge?.products?.[0]?.parameters?.startDateMission,
    );
    this.initStartDateMission();
    this.initChoiceDates(this.startDateMission);

    this.subscriptionFacade.initForm(this, {
      finalDateMission: this.firstChoiceValue,
    });
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }

  initStartDateMission() {
    const today = new Date();
    let tmpDate = this.startDateMission;
    tmpDate.setFullYear(today.getFullYear());

    if (tmpDate > today) {
      this.startDateMission.setFullYear(today.getFullYear() - 1);
    } else {
      this.startDateMission.setFullYear(today.getFullYear());
    }
  }

  initChoiceDates(startDateMission: Date) {
    const firstChoiceTmp = this.getFirstChoice(startDateMission);
    this.firstChoice = this.formatDate(firstChoiceTmp);
    this.firstChoiceValue = this.convertTimeZone(firstChoiceTmp);

    const secondChoiceTmp = this.getSecondChoice(startDateMission);
    this.secondChoice = this.formatDate(secondChoiceTmp);
    this.secondChoiceValue = this.convertTimeZone(secondChoiceTmp);
  }

  getFirstChoice(startDateMission: Date) {
    if (startDateMission.getMonth() >= 8) {
      startDateMission.setFullYear(startDateMission.getFullYear() + 1);
      startDateMission.setMonth(startDateMission.getMonth(), 0);
    } else {
      startDateMission = new Date('12/31/' + startDateMission.getFullYear());
      this.isShiftedMission = false;
    }

    return startDateMission;
  }

  getSecondChoice(startDateMission: Date) {
    if (this.isShiftedMission)
      startDateMission.setFullYear(startDateMission.getFullYear() - 1);
    return new Date('12/31/' + startDateMission.getFullYear());
  }

  formatDate(date: Date) {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();

    return `${day}/${month}/${year}`;
  }

  convertTimeZone(date: Date) {
    const dateToConvert = new Date(date.toISOString());

    return moment(dateToConvert).format();
  }
}
